export const getConfigValue = (key, buildTimeValue, hardcodedDefault) => {
    if (typeof window !== 'undefined' && window.RUNTIME_CONFIG
        && window.RUNTIME_CONFIG[key] !== undefined && window.RUNTIME_CONFIG[key] !== '') {
        return window.RUNTIME_CONFIG[key];
    }
    if (buildTimeValue !== undefined && buildTimeValue !== '') {
        return buildTimeValue;
    }
    return hardcodedDefault;
};

const {
    APP_VERSION,
    DEPLOYMENT_ENV,
    KC_AUTH_REALM,
    KC_CLIENT_ID,
    KC_AUTH_URL,
    REDIRECTION_URL,
    COOKIE_DOMAIN,
    DEUM_URL,
    DAF_SERVICE_URL,
    DL_SERVICE_URL,
    APM_SERVICE_URL,
    AMP_SERVICE_URL,
    EAF_SERVICE_URL,
    APS_SERVICE_URL,
    FIREBASE_API_KEY,
    FIREBASE_AUTH_DOMAIN,
    FIREBASE_PROJECT_ID,
    FIREBASE_STORAGE_BUCKET,
    FIREBASE_MESSAGING_SENDER_ID,
    FIREBASE_APP_ID,
    ELLA_LOCALE_TRANSLATION_EN_US_URL,
    ELLA_LOCALE_TRANSLATION_DE_DE_URL,
    DATADOG_RUM_APPLICATION_ID,
    DATADOG_CLIENT_TOKEN,
    DATADOG_SERVICE,
    DATADOG_ENABLE,
} = process.env;

export default {
    APP_VERSION: APP_VERSION || '',
    DEPLOYMENT_ENV: getConfigValue('DEPLOYMENT_ENV', DEPLOYMENT_ENV, undefined),
    APM_SERVICE_URL: getConfigValue('APM_SERVICE_URL', APM_SERVICE_URL, undefined),
    AMP_SERVICE_URL: getConfigValue('AMP_SERVICE_URL', AMP_SERVICE_URL, undefined),
    DEUM_URL: getConfigValue('DEUM_URL', DEUM_URL, undefined),
    DAF_SERVICE_URL: getConfigValue('DAF_SERVICE_URL', DAF_SERVICE_URL, undefined),
    DL_SERVICE_URL: getConfigValue('DL_SERVICE_URL', DL_SERVICE_URL, undefined),
    EAF_SERVICE_URL: getConfigValue('EAF_SERVICE_URL', EAF_SERVICE_URL, undefined),
    APS_SERVICE_URL: getConfigValue('APS_SERVICE_URL', APS_SERVICE_URL, undefined),
    KC_AUTH_REALM: getConfigValue('KC_AUTH_REALM', KC_AUTH_REALM, undefined),
    KC_CLIENT_ID: getConfigValue('KC_CLIENT_ID', KC_CLIENT_ID, undefined),
    KC_AUTH_URL: getConfigValue('KC_AUTH_URL', KC_AUTH_URL, undefined),
    REDIRECTION_URL: getConfigValue('REDIRECTION_URL', REDIRECTION_URL, undefined),
    COOKIE_DOMAIN: getConfigValue('COOKIE_DOMAIN', COOKIE_DOMAIN, undefined),
    FIREBASE_API_KEY: getConfigValue('FIREBASE_API_KEY', FIREBASE_API_KEY, undefined),
    FIREBASE_AUTH_DOMAIN: getConfigValue('FIREBASE_AUTH_DOMAIN', FIREBASE_AUTH_DOMAIN, undefined),
    FIREBASE_PROJECT_ID: getConfigValue('FIREBASE_PROJECT_ID', FIREBASE_PROJECT_ID, undefined),
    FIREBASE_STORAGE_BUCKET: getConfigValue('FIREBASE_STORAGE_BUCKET', FIREBASE_STORAGE_BUCKET, undefined),
    FIREBASE_MESSAGING_SENDER_ID: getConfigValue('FIREBASE_MESSAGING_SENDER_ID', FIREBASE_MESSAGING_SENDER_ID, undefined),
    FIREBASE_APP_ID: getConfigValue('FIREBASE_APP_ID', FIREBASE_APP_ID, undefined),
    ENDPOINTS: {
        DAMAGE_EVENTS: '/v1/damage-events',
        DAMAGE_EVENTS_V2: '/v2/damage-events',
        MEMBER: '/v1/member',
        INVOICE: '/v1/partners/current/invoices',
        MESSAGES: '/v1/damage-events',
        USERS: '/v1/users',
        FILES: '/v1/files',
        ATTACHMENTS: '/v1/attachments/get-upload-parameters',
        VP_CONTACTS: '/v1/vp-contacts',
        SUPPORT: '/v1/support',
    },
    DEFAULT_RECORDS_PER_PAGE: 10,
    DEFAULT_MESSAGES_REFRESH_TIME: 900000,
    ELLA_LOCALE_TRANSLATION_EN_US_URL: getConfigValue('ELLA_LOCALE_TRANSLATION_EN_US_URL', ELLA_LOCALE_TRANSLATION_EN_US_URL, undefined),
    ELLA_LOCALE_TRANSLATION_DE_DE_URL: getConfigValue('ELLA_LOCALE_TRANSLATION_DE_DE_URL', ELLA_LOCALE_TRANSLATION_DE_DE_URL, undefined),
    DATADOG_RUM_APPLICATION_ID: getConfigValue('DATADOG_RUM_APPLICATION_ID', DATADOG_RUM_APPLICATION_ID, undefined),
    DATADOG_CLIENT_TOKEN: getConfigValue('DATADOG_CLIENT_TOKEN', DATADOG_CLIENT_TOKEN, undefined),
    DATADOG_SERVICE: getConfigValue('DATADOG_SERVICE', DATADOG_SERVICE, undefined),
    DATADOG_ENABLE: getConfigValue('DATADOG_ENABLE', DATADOG_ENABLE, undefined),
    INTERSECTION_DATE: '01.01.2025',
};
